import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from '@/components/theme-provider';

/**
 * The provider stack that sits above the router. The router itself is supplied
 * by the entry point — `BrowserRouter` in the browser (`src/main.tsx`),
 * `StaticRouter` when prerendering (`scripts/prerender.tsx`) — so this stays
 * router-agnostic and both entries render exactly the same tree.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>{children}</ThemeProvider>
    </QueryClientProvider>
  );
}
